import { render } from "./TagNew.vue?vue&type=template&id=65566286&scoped=true&ts=true"
import script from "./TagNew.vue?vue&type=script&lang=ts"
export * from "./TagNew.vue?vue&type=script&lang=ts"

import "./TagNew.vue?vue&type=style&index=0&id=65566286&lang=less&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65566286"]])

export default __exports__